import { Action } from '@reduxjs/toolkit';

import { prepareAction } from '../helpers';

import { SET_NAVIGATOR_DASHBOARD_SLUG } from './types';

export const setNavigatorDashboardSlug = (dashboardSlug: string): Action =>
  prepareAction(SET_NAVIGATOR_DASHBOARD_SLUG, { dashboardSlug });
